<template>
	<v-row no-gutters>
		<v-col cols="12">
			<QuickMoneyBoard
				v-if='pageStyle === PageStyle.LaQuickMoney'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">>
			</QuickMoneyBoard>
			<PremierLottoBoard
				v-else-if='pageStyle === PageStyle.PremierLotto'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</PremierLottoBoard>
			<FastPayBoard
				v-else-if='pageStyle === PageStyle.FastPayTv'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</FastPayBoard>
			<SuperLottoBoard
				v-else-if='pageStyle === PageStyle.SuperLotto'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</SuperLottoBoard>
			<SiprizLottoBoard
				v-else-if='pageStyle === PageStyle.SiprizLotto'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</SiprizLottoBoard>
			<CaribbeanPickBoard
				v-else-if='pageStyle === PageStyle.CaribbeanPick'
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</CaribbeanPickBoard>
			<NoLimitBoard
				v-else-if="pageStyle === PageStyle.NoLimitLotto"
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</NoLimitBoard>
			<ParadiseLotteryBoard
				v-else-if="pageStyle === PageStyle.ParadiseLottery"
				:general-information='generalInformation'
				@change-style="$emit('change-style', $event)">
			</ParadiseLotteryBoard>
			<TriplePlayLotteryBoard
				v-else-if="pageStyle === PageStyle.TriplePlayLottery"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</TriplePlayLotteryBoard>
			<ArgentinaLotteryBoard
				v-else-if="pageStyle === PageStyle.ArgentinaLottery"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</ArgentinaLotteryBoard>
			<EasyMoneyBoard
				v-else-if="pageStyle === PageStyle.EasyMoney"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</EasyMoneyBoard>
			<QuickLottoBoard
				v-else-if="pageStyle === PageStyle.QuickLotto"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</QuickLottoBoard>
			<FantastikBoard
				v-else-if="pageStyle === PageStyle.FantastikLottery"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</FantastikBoard>
			<LeslycVipBoard
				v-else-if="pageStyle === PageStyle.LeslycVip"
				:general-information="generalInformation"
				@change-style="$emit('change-style', $event)">
			</LeslycVipBoard>
		</v-col>
		<div id="version">
			<span>v{{ boardVersion }}</span>
		</div>
	</v-row>
</template>
<script>
import PageStyle from '@/enumerations/PageStyle.json';
import moment from 'moment-timezone';
import {fetchGeneralParams} from '@/api/v2/board.api.js';
import numeral from 'numeral';
import Routes from "@admin/router/routes";

const VERSION = '1.9'

export default {
	name: 'Board',
	props: {
		apiToken: {
			type: String,
			required: false,
			default: null
		}
	},
	components: {
		CaribbeanPickBoard: () => import('@homepage/components/boards/CaribbeanPickBoard.vue'),
		SiprizLottoBoard: () => import('@homepage/components/boards/SiprizLottoBoard.vue'),
		NoLimitBoard: () => import("@homepage/components/boards/NoLimitBoard.vue"),
		PremierLottoBoard: () => import('@homepage/components/boards/PremierLottoBoard.vue'),
		QuickMoneyBoard: () => import('@homepage/components/boards/QuickMoneyBoard.vue'),
		FastPayBoard: () => import('@homepage/components/boards/FastPayBoard.vue'),
		SuperLottoBoard: () => import('@homepage/components/boards/SuperLottoBoard.vue'),
		ParadiseLotteryBoard: () => import('@homepage/components/boards/ParadiseLotteryBoard.vue'),
		TriplePlayLotteryBoard: () => import('@homepage/components/boards/TriplePlayLotteryBoard.vue'),
		ArgentinaLotteryBoard: () => import('@homepage/components/boards/ArgentinaLotteryBoard.vue'),
		EasyMoneyBoard: () => import('@homepage/components/boards/EasyMoneyBoard.vue'),
		QuickLottoBoard: () => import('@homepage/components/boards/QuickLottoBoard.vue'),
		FantastikBoard: () => import('@homepage/components/boards/FantastikLotteryBoard.vue'),
		LeslycVipBoard: () => import('@homepage/components/boards/LeslycVipBoard.vue'),
	},
	created() {
		// setTimeout(() => {
		// 	this.triggerredManually = true;
		// }, 5000)
	},
	destroyed() {
		this.stopClockTick();
	},
	data() {
		return {
			version: VERSION,
			secured: false,
			pageStyle: null,
			triggerredManually: false,
			generalInformation: {
				serverTimeZone: null,
				paramsFetched: false,
				sortition: {
					id: null,
					name: null,
					abbreviation: null,
					time: null,
					timeLeft: '00:00:00'
				},
				results: [],
				prizes: [],
				currentTime: null,
				lotteriesResultsEntries: [],
				sortedSortitions: []
			},
			PageStyle
		};
	},
	watch: {
		'generalInformation.currentTime'(currentTime) {
			if (currentTime) {
				this.onClockTick(currentTime);
			}
		},
	},
	methods: {
		onClockTick(currentTime) {
			const sortitionTime = moment(this.generalInformation.sortition.time).tz(this.generalInformation.serverTimeZone),
				timeLeftInSeconds = sortitionTime.diff(currentTime, 'seconds');

			if (timeLeftInSeconds <= 0 || this.triggerredManually) {
				if (this.triggerredManually) {
					console.log('Time is up!, triggered manually');
				} else {
					console.log('Time is up!, triggered automatically');
				}
				this.generalInformation.sortition.timeLeft = null;

				/* ResultDisplay path will determine depending on the page style
				 * if it should display the slot machine or the pixel streamer component
				 */

				this.$router.push({
					name: 'ResultDisplay',
					query: {
						pixelStreamVersion: this.pixelStreamVersion,
						apiToken: this.apiToken,
					},
					params: {
						sortition: this.generalInformation.sortition,
						pageStyle: this.pageStyle,
					}
				});
			} else {
				this.generalInformation.sortition.timeLeft = numeral(timeLeftInSeconds).format('00:00:00');
			}
		},
		startClockTick(time) {
			this.generalInformation.currentTime = time;
			return setInterval(() => {
				this.generalInformation.currentTime = this.generalInformation.currentTime.clone().add(1, 'second');
			}, 1000);
		},
		stopClockTick() {
			clearInterval(this.currentTimeInterval);
		}
	},
	computed: {
		boardVersion() {
			return this.secured ? `${this.version}-s` : `${this.version}`;
		},
		pixelStreamVersion() {
			const UE53Styles = [
				PageStyle.NoLimitLotto,
				PageStyle.ParadiseLottery,
				PageStyle.TriplePlayLottery,
				PageStyle.ArgentinaLottery,
				PageStyle.EasyMoney,
				PageStyle.QuickLotto,
				PageStyle.FantastikLottery,
				PageStyle.PremierLotto,
				PageStyle.FastPayTv
			]

			if (UE53Styles.includes(this.pageStyle)) {
				return '5.3';
			} else {
				return '5.0';
			}
		}
	},
	async beforeRouteEnter(to, _from, next) {
		try {
			const {data} = await fetchGeneralParams(to.query.apiToken);

			return next(vm => {
				vm.secured = data.secured;
				vm.pageStyle = data.style;
				vm.generalInformation.sortition.id = data.sortition?.id;
				vm.generalInformation.sortition.name = data.sortition?.name;
				vm.generalInformation.sortition.abbreviation = data.sortition?.abbreviation;
				vm.generalInformation.sortition.time = data.sortition?.time;
				vm.generalInformation.sortedSortitions = data.sortedSortitions;
				vm.generalInformation.results = data.results;
				vm.generalInformation.prizes = data.prizes;
				vm.generalInformation.lotteriesResultsEntries = data.lotteriesResultsEntries;
				vm.generalInformation.serverTimeZone = data.serverTimeZone;

				const currentServerTimeMoment = moment(data.serverTime).tz(data.serverTimeZone);
				vm.currentTimeInterval = vm.startClockTick(currentServerTimeMoment);
				vm.generalInformation.paramsFetched = true;
			});
		} catch (e) {

			return next({path: Routes.others.notFoundRoute.path})
		}
	}
};
</script>
<style>
html {
	overflow-y: auto
}

#version {
	font-weight: bold;
	position: absolute;
	border-radius: 8px;
	bottom: 0;
	right: 10px;
	color: white;
	font-size: 12px;
}
</style>
